import { computed } from 'vue';

/**
 * Composable for handling status-related functionality
 * @param {string} status - The status to get colors for
 * @returns {Object} - Object containing status-related functions and computed values
 */
export default function useStatus(status) {
    const getStatusColors = (statusValue) => {
        if (!statusValue) return "bg-gray-600/10 dark:bg-gray-600/20";
        
        switch(statusValue.toLowerCase()) {
            case "complete":
            case "paid":
            case "approved":
            case "active":
                return "text-green bg-green/10";
            case "pending":
                return "text-blue bg-blue/10";
            case "in progress":
                return "text-project-avocado bg-project-avocado/10";
            case "due":
            case "on hold":
                return "text-orange bg-orange/10";
            default:
                return "bg-gray-600/10 dark:bg-gray-600/20";
        }
    };

    const statusColors = computed(() => getStatusColors(status));

    return {
        getStatusColors,
        statusColors
    };
} 